import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ProfileAccountRow } from "web_myplann/Profile/Components/ProfileAccountRow";
import { ProfileSection } from "web_myplann/Profile/Components/ProfileSection";
import { PROFILE_ACCOUNT_ROWS } from "web_myplann/Profile/Constants/profileAccountRows";
import type { ProfileOverview } from "web_myplann/Profile/Types/ProfileOverview";

const R = Resources.Profile;

type Props = {
	profile: ProfileOverview;
};

export const ProfileAccountList: FC<Props> = ({ profile }) => {
	const { t } = useResource();
	const rows = PROFILE_ACCOUNT_ROWS.filter(({ field }) => profile[field]);

	return (
		<ProfileSection title={t(R.Overview.accountSection)}>
			{rows.map(({ field, icon, label, actionIcon, onAction }, index) => (
				<ProfileAccountRow
					key={field}
					icon={icon}
					label={t(label)}
					value={profile[field]}
					actionIcon={actionIcon}
					onClick={onAction && (() => onAction(profile[field]))}
					showDivider={index < rows.length - 1}
				/>
			))}
		</ProfileSection>
	);
};
